import initWhiteInstantSearchCatalog from './containers/catalog/Catalog';
import initWhiteInstantSearchPerfectFit from './containers/catalog/PerfectFit';

document.addEventListener('DOMContentLoaded', () => {
  initWhiteInstantSearchCatalog();
  initWhiteInstantSearchPerfectFit();
});
